import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Button/StableLabel.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function StableLabel({ labels, children }) {
  const shown = labels.indexOf(children);
  if (shown === -1) {
    return /* @__PURE__ */ jsxs("span", { className: "buyscout-stable-label", children: [
      labels.map((label, index) => /* @__PURE__ */ jsx("span", { className: "buyscout-stable-label__layer", "aria-hidden": "true", children: label }, index)),
      /* @__PURE__ */ jsx("span", { className: "buyscout-stable-label__layer", "data-shown": true, children })
    ] });
  }
  return /* @__PURE__ */ jsx("span", { className: "buyscout-stable-label", children: labels.map((label, index) => /* @__PURE__ */ jsx("span", { className: "buyscout-stable-label__layer", "data-shown": index === shown || void 0, "aria-hidden": index !== shown || void 0, children: label }, index)) });
}
StableLabel.displayName = "StableLabel";
export {
  StableLabel
};
//# sourceMappingURL=StableLabel.mjs.map